// import JoinRoom from './JoinRoom'
// import Room from './Room';
// import './styles.css'
// import bg5 from '../../../assets/images/bg5.jpg'
// import { useHMSStore, selectIsConnectedToRoom } from '@100mslive/react-sdk';

// const MobileLive = () => {
//     // const corsAnywhereUrl = 'https://cors-anywhere.herokuapp.com/';
//     // const audioUrl = 'http://128.140.52.151:8000/stream';

//     // // Combine the CORS Anywhere URL with your audio URL
//     // const proxyAudioUrl = corsAnywhereUrl + audioUrl;


//     //style="color:;display:block;font-family:Helvetica,sans-serif;font-size:11px;text-align:left;padding: 4px 0;"
//     const isConnected = useHMSStore(selectIsConnectedToRoom)
//     return (
//         <div style={{ backgroundImage: `url(${bg5})`, backgroundPosition: 'center', backgroundSize: 'cover', backgroundRepeat: 'no-repeat' }} className='flex flex-col justify-center items-center h-screen'>
//             <h1 style={{ marginTop: '-20px' }} className='text-xl border-b-4 border-white font-bold inline-block text-white'>লাইভ বয়ান</h1><br />
//             <audio src='https://stream.akabirbooks.com/stream' controls />
//             {/* <iframe src="https://khanqaherumi.mixlr.com/embed" frameborder="0" scrolling="no" height="300px" width="300px"></iframe> */}
//             <h1 className='text-white mt-4' >বিঃদ্রঃ লাইভ শোনার সময় অ্যাপস এর অন্য কোথাও যাওয়া যাবে না তবে অ্যাপস মিনিমাইজ করে মোবাইলের অন্য কাজ করা যাবে</h1>
//             {/* <h1 className='text-white mt-4' >বিঃদ্রঃ লাইভ সার্ভিস এই মুহূর্তে বন্ধ আছে। দয়া করে টেলিগ্রাম এর মাধ্যমে লাইভ বয়ান শুনুন। সার্ভিস চালু হলে সকলকে জানিয়ে দেওয়া হবে ইনশাল্লাহ</h1> */}
//             {/* {isConnected
//                 ? <Room />
//                 : <JoinRoom />
//             } */}
//         </div>
//     );
// }

// export default MobileLive;

// // import JoinRoom from './JoinRoom';
// // import Room from './Room';
// // import './styles.css';
// // import bg5 from '../../../assets/images/bg5.jpg';

// // const MobileLive = () => {
// //     return (
// //         <div style={{ backgroundImage: `url(${bg5})`, backgroundPosition: 'center', backgroundSize: 'cover', backgroundRepeat: 'no-repeat' }} className='flex flex-col justify-center items-center h-screen'>
// //             <h1 style={{ marginTop: '-20px' }} className='text-xl border-b-4 border-white font-bold inline-block text-white'>লাইভ বয়ান</h1><br />
// //             {/* Use an <iframe> to embed the audio stream */}
// //             <iframe src='http://128.140.52.151:8000/stream' width="100%" height="60" frameborder="0" allowfullscreen="true" webkitallowfullscreen="true" mozallowfullscreen="true"></iframe>
// //             <h1 className='text-white mt-4' >বিঃদ্রঃ লাইভ শোনার সময় অ্যাপস এর অন্য কোথাও যাওয়া যাবে না তবে অ্যাপস মিনিমাইজ করে মোবাইলের অন্য কাজ করা যাবে</h1>
// //             {/* You can include your Room and JoinRoom components here */}
// //         </div>
// //     );
// // }

// // export default MobileLive;


// // import JoinRoom from './JoinRoom';
// // import Room from './Room';
// // import './styles.css';
// // import bg5 from '../../../assets/images/bg5.jpg';

// // const MobileLive = () => {
// //     return (
// //         <div style={{ backgroundImage: `url(${bg5})`, backgroundPosition: 'center', backgroundSize: 'cover', backgroundRepeat: 'no-repeat' }} className='flex flex-col justify-center items-center h-screen'>
// //             <h1 style={{ marginTop: '-20px' }} className='text-xl border-b-4 border-white font-bold inline-block text-white'>লাইভ বয়ান</h1><br />
// //             {/* Use an <iframe> to embed the audio stream with full width */}
// //             <iframe src='http://128.140.52.151:8000/stream' width="100%" height="60" frameborder="0" allowfullscreen="true" webkitallowfullscreen="true" mozallowfullscreen="true"></iframe>
// //             <h1 className='text-white mt-4' >বিঃদ্রঃ লাইভ শোনার সময় অ্যাপস এর অন্য কোথাও যাওয়া যাবে না তবে অ্যাপস মিনিমাইজ করে মোবাইলের অন্য কাজ করা যাবে</h1>
// //             {/* You can include your Room and JoinRoom components here */}
// //         </div>
// //     );
// // }

// // export default MobileLive;
import { useState, useEffect, useRef } from 'react';
import bg5 from '../../../assets/images/bg5.jpg';
import flower from '../../../assets/images/flower.png'; // Add the new background image for the player
import './MobileLive.css';

const LiveStream = ({ setAudioData }) => {
  const [isPlaying, setIsPlaying] = useState(true);
  const audioRef = useRef(null);
  const [streamStartTime, setStreamStartTime] = useState(null);
  const [elapsedTime, setElapsedTime] = useState(0);

  useEffect(() => {
    if (!streamStartTime) return;

    // Parse the start time into a Date object (UTC)
    const startDate = new Date(streamStartTime);

    // Convert to Bangladesh Standard Time (BST)
    const options = {
      weekday: 'short',
      year: 'numeric',
      month: 'short',
      day: '2-digit',
      hour: '2-digit',
      minute: '2-digit',
      second: '2-digit',
      timeZoneName: 'short',
      timeZone: 'Asia/Dhaka',
    };

    const originalDate = new Date(startDate);
    const formattedDate = originalDate.toLocaleString('en-GB', options);
    console.log('Formatted date: ', formattedDate);

    // Convert the formattedDate back into a Date object for comparison
    const startTimeInBST = new Date(formattedDate);

    const interval = setInterval(() => {
      const currentTime = new Date();
      // Calculate elapsed time as the difference between current time and adjusted start time
      const elapsedSeconds = Math.floor((currentTime - startTimeInBST) / 1000);
      setElapsedTime(elapsedSeconds);
    }, 1000);

    return () => clearInterval(interval);
  }, [streamStartTime]);

  const formatTime = (seconds) => {
    const hours = Math.floor(seconds / 3600);
    const minutes = Math.floor((seconds % 3600) / 60);
    const secs = seconds % 60;

    return [
      hours.toString().padStart(2, '0'),
      minutes.toString().padStart(2, '0'),
      secs.toString().padStart(2, '0'),
    ].join(':');
  };

  const handleAudioPlay = () => {
    if (!audioRef.current.paused) {
      setIsPlaying(true);
    }
  };

  const handleAudioPause = () => {
    if (audioRef.current.paused) {
      setIsPlaying(false);
    }
  };

  useEffect(() => {
    const audioElement = audioRef.current;

    if (audioElement) {
      audioElement.addEventListener('play', handleAudioPlay);
      audioElement.addEventListener('pause', handleAudioPause);
      audioElement.addEventListener('ended', () => {
        audioElement.load();
        audioElement.play();
      });

      const autoplayAudio = async () => {
        try {
          await audioElement.play();
          setIsPlaying(true);
        } catch (error) {
          console.error('Autoplay blocked by browser:', error);
        }
      };

      autoplayAudio();
    }

    return () => {
      if (audioElement) {
        audioElement.removeEventListener('play', handleAudioPlay);
        audioElement.removeEventListener('pause', handleAudioPause);
        audioElement.removeEventListener('ended', () => {});
      }
    };
  }, []);

  useEffect(() => {
    fetch('https://stream.akabirbooks.com/status.xsl')
      .then((response) => response.text())
      .then((htmlString) => {
        const parser = new DOMParser();
        const doc = parser.parseFromString(htmlString, 'text/html');

        const streamStartedRow = Array.from(doc.querySelectorAll('td')).find(
          (td) => td.textContent.trim() === 'Stream started:'
        );

        if (streamStartedRow) {
          const startTime = streamStartedRow.nextElementSibling?.textContent.trim();

          if (startTime) {
            setStreamStartTime(startTime); // Store the parsed start time
            console.log('Stream started at:', startTime);
          } else {
            console.error('Start time not found');
          }
        } else {
          console.error("'Stream started' row not found in the table");
        }
      })
      .catch((error) => console.error('Error fetching Icecast status:', error));
  }, []);

  return (
    <div
      className="live-stream-container flex flex-col justify-center items-center h-screen bg-cover bg-center"
      style={{ backgroundImage: `url(${bg5})` }}
    >
      <div className="overlay bg-black bg-opacity-50 absolute inset-0"></div>

      <div className="content z-10 text-center text-white p-8">
        <h1 className="text-4xl font-bold border-b-4 border-white pb-4 mb-6">লাইভ বয়ান</h1>

        <div className="audio-player-container">
          <div className="audio-player-bg" style={{ backgroundImage: `url(${flower})` }}>
            {/* <audio
              ref={audioRef}
              src="https://d1kjc8r9depjqy.cloudfront.net/stream"
              controls
              className="audio-player"
            /> */}
            <button onClick={()=>setAudioData('https://d1kjc8r9depjqy.cloudfront.net/stream')} className='btn btn-accent'>Start Live</button>
          </div>
        </div>

        {/* <h1 className="mt-4 text-lg">
          বিঃদ্রঃ লাইভ শোনার সময় অ্যাপস এর অন্য কোথাও যাওয়া যাবে না তবে অ্যাপস মিনিমাইজ করে মোবাইলের অন্য কাজ করা যাবে
        </h1> */}
        <p>Elapsed Time: {formatTime(elapsedTime)}</p>
      </div>
    </div>
  );
};

export default LiveStream;

// import React, { useState } from 'react';

// const AudioPlayer = () => {
//   const [isPlaying, setIsPlaying] = useState(false);
//   const audioRef = React.useRef(null);

//   const togglePlayPause = () => {
//     if (isPlaying) {
//       audioRef.current.pause();
//     } else {
//       audioRef.current.play();
//     }
//     setIsPlaying(!isPlaying);
//   };

//   return (
//     <div>
//       <audio ref={audioRef} src="https://d1kjc8r9depjqy.cloudfront.net/stream" />
//       <button onClick={togglePlayPause}>
//         {isPlaying ? 'Pause' : 'Play'}
//       </button>
//     </div>
//   );
// };

// export default AudioPlayer;


